import { Value } from "../value.js";
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/ident}
 *
 * @public
 */
export class Ident extends Value {
    _value;
    constructor(type, value) {
        super(type, false);
        this._value = value;
    }
    get value() {
        return this._value;
    }
    is(...values) {
        return values.includes(this._value);
    }
    resolve() {
        return this;
    }
    equals(value) {
        return value instanceof Ident && value._value === this._value;
    }
    hash(hash) {
        hash.writeString(this._value);
    }
    toJSON() {
        return {
            ...super.toJSON(),
            value: this._value,
        };
    }
    toString() {
        return this._value;
    }
}
/**
 * @public
 */
(function (Ident) {
    function isIdent(value) {
        return value instanceof Ident;
    }
    Ident.isIdent = isIdent;
})(Ident || (Ident = {}));
//# sourceMappingURL=ident.js.map